__turbopack_context__.v({
  "active": "Navigation-module__l8qRma__active",
  "avatarInitial": "Navigation-module__l8qRma__avatarInitial",
  "cartCount": "Navigation-module__l8qRma__cartCount",
  "cartWrapper": "Navigation-module__l8qRma__cartWrapper",
  "logo": "Navigation-module__l8qRma__logo",
  "logoLink": "Navigation-module__l8qRma__logoLink",
  "mobileMenuButton": "Navigation-module__l8qRma__mobileMenuButton",
  "mobileMenuItem": "Navigation-module__l8qRma__mobileMenuItem",
  "mobileMenuOverlay": "Navigation-module__l8qRma__mobileMenuOverlay",
  "mobileSelectorsColumn": "Navigation-module__l8qRma__mobileSelectorsColumn",
  "navItem": "Navigation-module__l8qRma__navItem",
  "navItemWithDropdown": "Navigation-module__l8qRma__navItemWithDropdown",
  "navigationWrapper": "Navigation-module__l8qRma__navigationWrapper",
  "open": "Navigation-module__l8qRma__open",
  "rightControls": "Navigation-module__l8qRma__rightControls",
  "scrolled": "Navigation-module__l8qRma__scrolled",
  "scrolledLinks": "Navigation-module__l8qRma__scrolledLinks",
  "scrolledNav": "Navigation-module__l8qRma__scrolledNav",
  "searchAndControls": "Navigation-module__l8qRma__searchAndControls",
  "searchContainer": "Navigation-module__l8qRma__searchContainer",
  "selectorSlot": "Navigation-module__l8qRma__selectorSlot",
});
